import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccount from '../reducers/account.reducer';

export const selectState = createFeatureSelector<fromAccount.State>(
  fromAccount.featureKey
);

export const getUser = createSelector(selectState, (state) => state.user);
export const getUserTransaction = createSelector(selectState, (state) => state.transactions);
export const getUserContacts = createSelector(selectState, (state) => state.contacts);
